module.exports = __webpack_public_path__ + "img/avaliacao_banner.a11c530c.png";